<template>
  <ion-button
      v-bind="$attrs"
      @click="handleClick"
      :class="`btn ${hide && 'collapsed'} ${fullWidth && 'full-width'}`"
  >
    <ion-icon
        v-if="props.icon"
        slot="start"
        :icon="props.icon"
    ></ion-icon>
    <div class="content">
      <slot></slot>
    </div>
  </ion-button>
</template>

<script setup lang="ts">
import {IonButton, IonIcon} from '@ionic/vue';

const emit = defineEmits(['click'])

const handleClick = (event: any) => {
  emit('click', event)
}

const props = defineProps({
  icon: {
    type: Object,
    default: false
  },
  hide: {
    type: Boolean,
    default: false
  },
  fullWidth: {
    type: Boolean,
    default: false
  }
});

defineOptions({
  inheritAttrs: true
});
</script>

<style scoped>
.btn {
  --border-radius: 12px;
  --border-color: #e2e8f0;
  --border-width: 1px;
  --background: transparent;
  --color: #363131;
  --padding-start: 16px;
  --box-shadow: none;
  height: 54px;
  margin: 0;
  text-transform: none;
  display: flex;
  justify-content: space-between;

  max-width: 200px;
  overflow: hidden;
  transition:
      max-width 0.35s ease-in-out,
      opacity 0.25s ease-in-out,
      margin 0.35s ease-in-out;
}

.btn:hover {
  --background: rgb(197 197 197 / 0.08);
}

.btn.full-width {
  width: 100%;
  max-width: 100%;
}

.btn.collapsed {
  max-width: 0;
  opacity: 0;
  pointer-events: none;

  --padding-start: 0px;
  --padding-end: 0px;
  --border-width: 0px;

  margin: 0;
}

.content {
  flex: 1;
  white-space: nowrap;
}
</style>